module.exports = __webpack_public_path__ + "img/Maker_Medal.c6a800c8.svg";